/**
 * Created by klerick on 27.12.16.
 */
'use strict';
angular.module('webtrader').service('OpenListOptions', function($q, $document) {

    let _currentStatus = false;
    let _data = [];
    let _type = '';
    let _openPromise;

    let onClick = () => {
        this.close();
    };

    this.open = function (type, data) {
        _data = data;
        _currentStatus = true;
        _type = type;
        _openPromise = $q.defer();



        $document.on('click', onClick) ;

        return _openPromise.promise;
    };


    this.close = function (data) {
        _currentStatus = false;
        _data = [];
        _type = '';

        if (_openPromise && _openPromise.resolve) {
            _openPromise.resolve(data);
            _openPromise = '';
        }

        $document.off('click', onClick);
    };

    Object.defineProperties(this, {
        isOpen: {
            get: function () {
                return _currentStatus;
            }
        },
        data: {
            get: function() {
                return _data;
            }
        },
        type: {
            get: function() {
                return _type;
            }
        }

    });
});
